__turbopack_context__.v({
  "scroll": "Sidebar-module__dzmq8G__scroll",
});
